// extracted by mini-css-extract-plugin
export default {"tablefooter":"TableFooter_tablefooter__8YivM","tablefooter__pagination":"TableFooter_tablefooter__pagination__LBbiC"};